import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';
import { getCanoneMarketplace } from '../services/api';
import { Container, Card, Button, Row, Col, Spinner, Alert } from 'react-bootstrap';

function CanoniMarketplaceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const tornaIndietro = useTornaIndietro('/canoni-marketplace');
  const [canone, setCanone] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCanone = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getCanoneMarketplace(id);
        setCanone(response.data);
      } catch (err) {
        setError('Errore nel caricamento del canone.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchCanone();
  }, [id]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Caricamento canone...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
        <Button variant="primary" onClick={tornaIndietro}>Torna alla lista</Button>
      </Container>
    );
  }

  if (!canone) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">Canone non trovato.</Alert>
        <Button variant="primary" onClick={tornaIndietro}>Torna alla lista</Button>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Row className="mb-3 align-items-center">
        <Col>
          <h2 className="mb-0">Dettaglio Canone: {canone.denominazione}</h2>
        </Col>
        <Col xs="auto" className="ms-auto">
          <Button variant="secondary" onClick={() => navigate('/canoni-marketplace')} className="me-2">
            Indietro
          </Button>
          <Button variant="warning" onClick={() => navigate(`/canoni-marketplace/edit/${id}`)}>
            Modifica
          </Button>
        </Col>
      </Row>

      <Card>
        <Card.Header as="h5">Dati Canone Marketplace</Card.Header>
        <Card.Body>
          <Row>
            <Col md={12}>
              <Row className="mb-2">
                <Col xs={4}><strong>ID:</strong></Col>
                <Col xs={8}>{canone.id}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Denominazione:</strong></Col>
                <Col xs={8}>{canone.denominazione}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Percentuale:</strong></Col>
                <Col xs={8}>{canone.percentuale}%</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Costo Fisso:</strong></Col>
                <Col xs={8}>€ {canone.costo_fisso.toFixed(2)}</Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default CanoniMarketplaceDetail;
